<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">{{goodsServices.name}} - {{goodsServices.variety}}</h4>
                        <h6 class="card-subtitle">View details description, edit rate, add property</h6>
                    </div>

                    <div class="card-body pt-0 pb-0">
                        <div class="row">
                            <div class="col-lg-3 col-sm-4 border-bottom mt-3">
                                <p class="font-weight-bold text-right">Name :</p>
                            </div>
                            <div class="col-lg-3 col-sm-8 border-bottom mt-3">
                                <p class="form-control-static">{{goodsServices.name}}</p>
                            </div>

                            <div class="col-lg-3 col-sm-4 border-bottom mt-3">
                                <p class="font-weight-bold text-right">Variety :</p>
                            </div>
                            <div class="col-lg-3 col-sm-8 border-bottom mt-3">
                                <p class="form-control-static">{{goodsServices.variety}}</p>
                            </div>

                            <div class="col-lg-3 col-sm-4 border-bottom mt-3">
                                <p class="font-weight-bold text-right">Native Name :</p>
                            </div>
                            <div class="col-lg-3 col-sm-8 border-bottom mt-3">
                                <p class="form-control-static">{{goodsServices.native}}</p>
                            </div>

                            <div class="col-lg-3 col-sm-4 border-bottom mt-3">
                                <p class="font-weight-bold text-right">Description :</p>
                            </div>
                            <div class="col-lg-3 col-sm-8 border-bottom mt-3">
                                <p class="form-control-static">{{goodsServices.description}}</p>
                            </div>

                            <div class="col-lg-3 col-sm-4 border-bottom mt-3">
                                <p class="font-weight-bold text-right">Category :</p>
                            </div>
                            <div class="col-lg-3 col-sm-8 border-bottom mt-3">
                                <goods-services-category :category="goodsServices.category"/>
                            </div>

                            <div class="col-lg-3 col-sm-4 border-bottom mt-3">
                                <p class="font-weight-bold text-right">Rate :</p>
                            </div>
                            <div class="col-lg-3 col-sm-8 border-bottom mt-3">
                                <p class="form-control-static">{{goodsServices.rate | money}}</p>
                            </div>

                            <div class="col-lg-3 col-sm-4 mt-3">
                                <p class="font-weight-bold text-right">Properties :</p>
                            </div>
                            <div class="col-lg-9 col-sm-8 mt-3">
                                <span v-bind:key="index" v-for="(gsp, index) in goodsServices.goods_services_props">
                                    <p class="form-control-static">{{gsp.key | capitalize}}: {{gsp.value}}</p>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer" style="height: 70px">

                    </div>
                </div>
            </div>

            <div class="col-lg-7 col-sm-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Add Property</h4>
                        <h6 class="card-subtitle">Add Goods/Services properties which ensure quality</h6>
                    </div>
                    <form @submit.prevent="handleCommPropSubmit" class="form-horizontal" data-vv-scope="prop-form">
                        <div class="card-body mt-4">
                            <div class="form-group row" v-bind:key="index" v-for="(row, index) in goods_services_props">
                                <label :for="'goodsService_id'+index" class="col-sm-3 text-right control-label col-form-label" v-if="index === 0">Property</label>
                                <label class="col-sm-3" v-if="index > 0"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': goods_services_prop_submitted && errors.has('propname'+index)}"
                                           :name="'propname'+index"
                                           class="form-control"
                                           data-vv-as="propname"
                                           placeholder="Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.key"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="goods_services_prop_submitted && errors.has('propname'+index)">{{ errors.first('propname'+index) }}</div>
                                </div>
                                <div class="col-sm-4">
                                    <input :class="{'is-invalid': goods_services_prop_submitted && errors.has('propval'+index)}"
                                           :name="'propval'+index"
                                           class="form-control"
                                           data-vv-as="propval"
                                           placeholder="Description"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.value"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="goods_services_prop_submitted && errors.has('propval'+index)">{{ errors.first('propval'+index) }}</div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group button-group">
                                        <button @click="addRow()" class="btn btn-success" style="height: 40px;" type="button" v-if="index === goods_services_props.length - 1"><i
                                                class="fa fa-plus"></i>
                                        </button>
                                        <button @click="removeRow(index)" class="btn btn-danger" style="height: 40px;" type="button" v-else><i class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="resetGoodsServicesProp()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-5 col-sm-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Add New Rate</h4>
                        <h6 class="card-subtitle">Rates can be dynamic</h6>
                    </div>
                    <form @submit.prevent="handleRateSubmit" class="form-horizontal" data-vv-scope="rate-form">
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="rate">Rate</label>
                                <div class="col-sm-9">
                                    <input :class="{'is-invalid': submitted && errors.has('rate-form.rate')}" class="form-control"
                                           data-vv-as="rate"
                                           id="rate"
                                           name="rate"
                                           placeholder="Rate"
                                           step="any"
                                           type="number"
                                           v-model="rate"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.rate')">{{ errors.first('rate-form.rate') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Currency</label>
                                <div class="col-sm-9">
                                    <input :value="currentOrg.currency_symbol" class="form-control" readonly type="text" v-if="currentOrg.currency_symbol">
                                    <input class="form-control" readonly type="text" v-if="!currentOrg.currency_symbol" value="N/A">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.currency')">{{ errors.first('rate-form.currency') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="resetRate()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import GoodsServicesCategory from "../GoodsServicesCategory";

    export default {
        name: "ViewAndEdit",
        props: ["goodsservicesid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate, GoodsServicesCategory},
        data() {
            return {
                submitted: false,
                goods_services_prop_submitted: false,
                goodsServices: {
                    id: null,
                    express_id: null,
                    name: null,
                    variety: null,
                    native: null,
                    description: null,
                    category: null,
                    rate: {},
                    unit: {},
                    goods_services_props: [],
                    attachments: [],
                    created_at: null
                },
                rate: null,
                goods_services_props: [{
                    key: null,
                    value: null
                }],
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getGoodsServices();
            },
            async getGoodsServices() {
                try {
                    $(".preloader").fadeIn();
                    let row = await this.$http.get(`/express/${this.currentOrg.express_id}/goodsservices/${this.goodsservicesid}`);
                    $(".preloader").fadeOut();
                    this.goodsServices = row.data;
                    this.rate          = this.goodsServices.rate.amount;
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            async handleRateSubmit() {
                this.submitted = true;
                let valid      = await this.$validator.validateAll('rate-form');

                if(valid) {
                    await this.saveRate();
                }
            },
            async saveRate() {
                try {
                    await this.$http.post(`/express/${this.currentOrg.express_id}/goodsservices/${this.goodsservicesid}/rate`, {rate: this.rate});
                    this.$toastr('success', 'New rate added', 'Success');
                    this.getGoodsServices();
                    this.resetRate();
                } catch(e) {
                }
            },
            async resetRate() {
                this.submitted = false;
                this.rate      = this.goodsServices.rate.amount;
            },
            async handleCommPropSubmit(scope) {
                this.goods_services_prop_submitted = true;
                let valid                          = await this.$validator.validateAll('prop-form')
                if(valid) {
                    await this.saveGoodsServicesProp();
                }
            },
            async saveGoodsServicesProp() {
                try {
                    await this.$http.post(`/express/${this.currentOrg.express_id}/goodsservices/${this.goodsservicesid}/props`, this.goods_services_props);
                    this.getGoodsServices();
                    this.goods_services_props = [{
                        key: null,
                        value: null
                    }];
                    this.$toastr('success', 'Goods/Services Property added', 'Success');
                } catch(err) {
                    this.$toastr('error', 'Goods/Services Property update failed.', 'Failed');
                }
            },
            resetGoodsServicesProp() {
                this.goods_services_props = [{
                    key: null,
                    value: null
                }]
            },
            addRow() {
                this.goods_services_props.push({
                    key: null,
                    value: null
                });
            },
            removeRow(index) {
                this.goods_services_props.splice(index, 1);
            }
        }
    }
</script>

<style scoped>

</style>
